window.Products.DeviceCase.GalaxyS9 = function() {
};
window.Products.DeviceCase.GalaxyS9.inherits(window.Products.DeviceCase.DeviceCase);

window.Products.DeviceCase.GalaxyS9.id = 75;
window.Products.DeviceCase.GalaxyS9.slug = 'galaxy-s9';
window.Products.DeviceCase.GalaxyS9.has_3d = true;
window.Products.DeviceCase.GalaxyS9.dpi = 300;

window.Products.DeviceCase.GalaxyS9.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	
	// Trust me it really fixes the camera
	modelViewer.camera.position.z = 100;

	modelViewer.object.position.y = 0.05;
};

window.Products.DeviceCase.GalaxyS9.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.5;
	controls.maxDistance = 4.5;
};

window.Products.DeviceCase.GalaxyS9.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[1].map = modelViewer.texture;
};